/* 📊 بكسلات التتبع — Meta / TikTok / Snap / GA4.
   أي زائر يدخل التطبيق يصبح مستهدفاً بجماهير إعادة الاستهداف تلقائياً. */
import { useEffect } from "react";
import http from "@/api";

let injected = false;
const state = { meta: false, tiktok: false, snap: false, ga4: false };

function addScript(code) {
  const s = document.createElement("script");
  s.async = true;
  s.text = code;
  document.head.appendChild(s);
}

function addSrc(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export default function PixelsLoader() {
  useEffect(() => {
    if (injected) return;
    injected = true;
    http.get("/public/pixels").then(({ data }) => {
      if (data.meta_pixel_id) {
        addScript(`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${data.meta_pixel_id}');fbq('track','PageView');`);
        state.meta = true;
      }
      if (data.tiktok_pixel_id) {
        addScript(`!function (w, d, t) {w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load('${data.tiktok_pixel_id}');ttq.page();}(window, document, 'ttq');`);
        state.tiktok = true;
      }
      if (data.snap_pixel_id) {
        addScript(`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u);})(window,document,'https://sc-static.net/scevent.min.js');snaptr('init','${data.snap_pixel_id}');snaptr('track','PAGE_VIEW');`);
        state.snap = true;
      }
      if (data.ga4_id) {
        addSrc(`https://www.googletagmanager.com/gtag/js?id=${data.ga4_id}`);
        addScript(`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${data.ga4_id}');`);
        state.ga4 = true;
      }
    }).catch(() => {});
  }, []);
  return null;
}

/* يُستدعى عند كل تنقل صفحة (من behavior.js) */
export function pixelPage(pathname) {
  try {
    if (window.fbq) window.fbq("track", "PageView");
    if (window.ttq?.page) window.ttq.page();
    if (window.snaptr) window.snaptr("track", "PAGE_VIEW");
    if (pathname === "/checkout") pixelTrack("begin_checkout", {});
  } catch { /* pixels must never break the app */ }
}

/* يُستدعى من trackAction — يحول أحداثنا لأحداث البكسلات القياسية */
export function pixelTrack(name, meta = {}) {
  try {
    const value = Number(meta.total || meta.price || 0) || 0;
    const common = { value, currency: "QAR" };
    const metaMap = { add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout", order_placed: "Purchase", product_view: "ViewContent" };
    const ttMap = { add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout", order_placed: "CompletePayment", product_view: "ViewContent" };
    const snapMap = { add_to_cart: "ADD_CART", begin_checkout: "START_CHECKOUT", order_placed: "PURCHASE", product_view: "VIEW_CONTENT" };
    if (window.fbq && metaMap[name]) window.fbq("track", metaMap[name], common);
    if (window.ttq?.track && ttMap[name]) window.ttq.track(ttMap[name], { value, currency: "QAR" });
    if (window.snaptr && snapMap[name]) window.snaptr("track", snapMap[name], { price: value, currency: "QAR" });
    if (window.gtag && name === "order_placed") window.gtag("event", "purchase", { value, currency: "QAR", transaction_id: meta.order_code || "" });
  } catch { /* silent */ }
}
